import { render } from "./TopicPerformance.vue?vue&type=template&id=538ccd5e&scoped=true"
import script from "./TopicPerformance.vue?vue&type=script&lang=js"
export * from "./TopicPerformance.vue?vue&type=script&lang=js"

import "./TopicPerformance.vue?vue&type=style&index=0&id=538ccd5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538ccd5e"]])

export default __exports__